import { Controller } from '@hotwired/stimulus';

import Local from '@/modules/local';
import ModuleLoader from '@/modules/module_loader';

export default class extends Controller {
  connect() {
    const options = ModuleLoader.getOptions();

    new Local({ count_param: options.count_param }).create();
  }
}
